<mibi-box-layout>

<footer class="mibi-footer">
  <mibi-last-change-display-container class="mibi-footer__left"></mibi-last-change-display-container>
  <mibi-footer-nav-container class="mibi-footer__right"></mibi-footer-nav-container>
</footer>

</mibi-box-layout>
